import { memo, ReactNode } from 'react';

import { Text } from '@components/Text';

export const FieldDescription = memo<{ description?: ReactNode }>(({ description }) => {
  if (!description) return null;

  if (typeof description === 'string') {
    return (
      <Text $level={5} color="text-gray-400" className="font-light text-justify leading-4 mt-2">
        {description}
      </Text>
    );
  }
  return <div className="mt-2">{description}</div>;
});

FieldDescription.displayName = 'FieldDescription';
